module.exports = __webpack_public_path__ + "img/x_blue.52f919cf.svg";